module.exports = __webpack_public_path__ + "img/31_33.8719dd68.png";